import { SET_TOWN, INIT_TOWN } from '../constants/actions'

const initState = {}

export default (state = initState, action) => {
  switch (action.type) {
    case SET_TOWN:
      return action.town
    case INIT_TOWN:
      return action.town
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/town.js